// Pure helpers for choosing which photo goes in which comparison slot.
// A check-in stores photos as photo_<poseKey> fields, so "does this check-in
// have that pose" is a field lookup — but it is done in four places by the
// picker, so it lives here and is tested once.

// Order matters: it is the order the pose selects list, and the order
// defaultSecondPose scans.
export const ALL_POSE_KEYS = [
  'front', 'side', 'back', 'front_flex', 'side_flex', 'back_flex', 'relaxed',
];

export function hasPose(checkIn, poseKey) {
  return !!(checkIn && checkIn[`photo_${poseKey}`]);
}

export function posesIn(checkIn) {
  return ALL_POSE_KEYS.filter(p => hasPose(checkIn, p));
}

// Row 2's default: the first pose OTHER than row 1's that both check-ins have,
// so front+back falls out automatically. Falls back to firstPose (row 2 then
// duplicates row 1, which is valid and visible rather than empty).
export function defaultSecondPose(beforeCheckIn, afterCheckIn, firstPose) {
  const both = ALL_POSE_KEYS.filter(
    p => p !== firstPose && hasPose(beforeCheckIn, p) && hasPose(afterCheckIn, p)
  );
  return both[0] || firstPose;
}

// One entry of PhotoComparisonViewer's `pairs` prop, built from two check-ins
// and the pose chosen for each side. Shared by both compare surfaces — a
// second copy in the other page is exactly the drift this module prevents.
export function buildPair(id, beforePose, afterPose, beforeCheckIn, afterCheckIn) {
  const side = (ci, pose) => ({
    photoUrl: ci?.[`photo_${pose}`] || null,
    keypoints: ci?.photo_keypoints?.[pose] || null,
    checkInId: ci?.id || null,
    weightKg: ci?.weight_kg ?? null,
    bodyFat: ci?.body_fat_percent ?? null,
    date: ci?.date || null,
  });
  return {
    id: `${id}-${beforePose}-${afterPose}`,
    poseType: { before: beforePose, after: afterPose },
    before: side(beforeCheckIn, beforePose),
    after: side(afterCheckIn, afterPose),
  };
}
